import config from 'react-global-configuration';
import { FormikValues } from '../components/SearchAllContent/types';

export default async function exportBibciteReferences(values: FormikValues) {
  const API_URL = config.get('API_URL');

  const idsToExport = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(values)) {
    if (idsToExport.length > 99) {
      break;
    }

    if (key.match(/[0-9]/g) && value === true) {
      idsToExport.push(key);
    }
  }

  const response = await fetch(`${API_URL}/api/bibcite_export?_format=json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      format: values.format,
      ids: idsToExport,
      email: values.email,
      subject: values.subject,
      message: values.message,
    }),
  });

  const data = await response.json();

  if (!data.email) {
    const link = document.createElement('a');
    link.download = data.name;
    link.href = `${API_URL}${data.url}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return {
    status: response.status,
    data,
  };
}
